import { RouteComponentProps, useParams } from "@reach/router";
import { FunctionComponent, lazy, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useQuery } from "../../utils/query";
import ErrorFallback from "../shared/ErrorFallback";

interface IProps extends RouteComponentProps {
	loggedIn: boolean;
	theme: [string, (value: string) => void];
	refreshMenu(): void;
}

const LazySettings = lazy(() => import(/* webpackChunkName: "Settings" */ "./Settings"));

const SettingsPage: FunctionComponent<IProps> = (props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { loggedIn, theme, refreshMenu, path } = props;

	if (!loggedIn) {
		return <></>;
	}

	return <ErrorBoundary FallbackComponent={ErrorFallback}>
		<LazySettings themeState={theme} refreshMenu={refreshMenu} />
	</ErrorBoundary>;
};

export default SettingsPage;